import React from 'react';

/**
 * Primary action button from the Figma design system ("boton negro").
 * Black filled pill with white Semi-Bold Inter label.
 *
 * Usage:
 *   <BotonNegro onClick={...}>Ver bonos</BotonNegro>
 *   <BotonNegro as="a" href="/signup">Crear cuenta</BotonNegro>
 *   <BotonNegro fullWidth>Confirmar pago $900</BotonNegro>
 */
export default function BotonNegro({
  children,
  as: Component = 'button',
  fullWidth = false,
  className = '',
  ...rest
}) {
  return (
    <Component
      {...rest}
      className={[
        'inline-flex items-center justify-center gap-2.5',
        'rounded-md bg-ink px-8 py-2.5 font-sans text-sm font-semibold text-white',
        'transition-opacity hover:opacity-90 active:opacity-80',
        'focus:outline-none focus:ring-2 focus:ring-ink focus:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        fullWidth ? 'w-full' : '',
        className,
      ].join(' ')}
    >
      {children}
    </Component>
  );
}
